
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BoardUseCustomBPI"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Board"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"use_custom_bpi"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoardResult"},"directives":[]}]}}],"loc":{"start":0,"end":115}};
    doc.loc.source = {"body":"#import \"./BoardResultFragment.graphql\"\n\nfragment BoardUseCustomBPI on Board {\n  use_custom_bpi\n  ...BoardResult\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./BoardResultFragment.graphql").definitions));


      module.exports = doc;
    



//////////////////
// WEBPACK FOOTER
// ./src/graphql/BoardUseCustomBPIFragment.graphql
// module id = 6tTx
// module chunks = 1